import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  data: [],
  selected: {},
  namesOnly: [],
  shared: {
    namesOnly: [],
    lastFetched: null
  },
  networkActivityFilter: [],
  networkActivityFilterChanged: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_NETWORKS:
      return { ...state, data: action.obj }

    case actionTypes.SET_SELECTED_NETWORK:
      return { ...state, selected: action.obj }

    case actionTypes.SET_NETWORK_NAMES:
      return { ...state, namesOnly: action.obj }

    case actionTypes.SET_SHARED_NETWORK_NAMES:
      return {
        ...state,
        shared: { namesOnly: action.obj, lastFetched: new Date() }
      }
    case actionTypes.SET_NETWORK:
      return {
        ...state,
        data: state.data.map(network => {
          if (network.id !== action.data.id) {
            return network
          }
          return { ...network, ...action.data }
        })
      }
    case actionTypes.SET_NETWORK_ACTIVITY_FILTER:
      return {
        ...state,
        networkActivityFilter: action.arr,
        networkActivityFilterChanged: action.makeDirty
      }
    default:
      return state
  }
}

export default reducer
